import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '@/lib/supabase';
import type { Organization } from '@/types/organizationTypes';

export function useOrganization() {
  const { organizationId } = useAuth();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchOrganization() {
      if (!organizationId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        const { data, error } = await supabase
          .from('organizations')
          .select('*')
          .eq('id', organizationId)
          .single();
          
        if (error) throw error;
        
        // Parse JSON fields if present and only if they are strings
        const org = {
          ...data,
          billing_settings: typeof data.billing_settings === 'string' ? JSON.parse(data.billing_settings) : data.billing_settings,
          class_defaults: typeof data.class_defaults === 'string' ? JSON.parse(data.class_defaults) : data.class_defaults,
          parent_portal_settings: typeof data.parent_portal_settings === 'string' ? JSON.parse(data.parent_portal_settings) : data.parent_portal_settings,
        };
        setOrganization(org);
      } catch (err) {
        console.error('Error loading organization:', err);
        setError(err instanceof Error ? err : new Error('Failed to load organization'));
      } finally {
        setLoading(false);
      }
    }

    fetchOrganization();
  }, [organizationId]);

  return { organization, loading, error };
} 